export default "__VITE_ASSET__DBIVlxun__"